import { forwardRef } from 'react';
import { useTranslation } from 'src/hooks/use-translation';
import Link from '@mui/material/Link';

import { Link as RouterLink } from 'src/components/link';
import Box, { BoxProps } from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import MentaSvg from 'icons/colored/menta.svg';

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
  width?: string;
  height?: string;
  fullIcon?: boolean;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  (
    { disabledLink = false, sx, width = '40px', height = '40px', fullIcon = false, ...other },
    ref
  ) => {
    const { t } = useTranslation('', { keyPrefix: 'logo' });
    const theme = useTheme();

    const logo = (
      <Box
        ref={ref}
        sx={{
          display: 'inline-flex',
          ...sx,
        }}
        {...other}
      >
        {fullIcon ? (
          <img
            src={theme.palette.mode === 'dark' ? '/assets/logo-dark.png' : '/assets/logo.png'}
            width={width}
            height={height}
            alt={t('alt')}
          />
        ) : (
          <MentaSvg width={width} height={height} role="img" aria-label={t('alt')} />
        )}
      </Box>
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link component={RouterLink} to="/" aria-label={t('home')} sx={{ display: 'contents' }}>
        {logo}
      </Link>
    );
  }
);

Logo.displayName = 'Logo';

export { Logo };
